import { formatDateStr } from '../../utils/DateUtil';
import { getAbstractAddress, getGoAddress } from '../../utils/PageAddressUtil';

export default function BlogCardLatestPosts({ statusOk, posts }) {
    if (!posts || posts.length === 0) return null;

    return (
        <div>
            <div className="redesign-blog-latest-title">最新文章</div>
            {posts.map((post, index) => (
                <div className="redesign-blog-latest-item" key={index}>
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={statusOk ? getGoAddress(post.link) : getAbstractAddress(post.link)}
                    >
                        {post.title}
                    </a>
                    <span className="redesign-blog-latest-date">{formatDateStr(post.publishedAt, true)}</span>
                </div>
            ))}
        </div>
    );
}
